import { BRANDS } from "@/data/content";

export const Marquee = () => {
  const items = [...BRANDS, ...BRANDS];
  return (
    <div className="relative border-y-[1.5px] border-[var(--ink)] bg-[var(--yellow)] py-4 overflow-hidden -rotate-1 my-8" data-testid="brand-marquee">
      <div className="marquee-track">
        {items.map((b, i) => (
          <span key={i} className="flex items-center gap-8 px-4 font-pixel text-2xl md:text-3xl uppercase whitespace-nowrap">
            {b}
            <span className="w-2.5 h-2.5 rounded-full bg-[var(--ink)]" />
          </span>
        ))}
      </div>
    </div>
  );
};
